import { AugmentedUpdateClientPresentationV2Input } from '@/types/schema';

/**
 * The bundles a payload writes, so the queue knows what to drop if it fails.
 *
 * An `updateBundles` entry carrying nothing but a position is a reorder, which
 * belongs to the list rather than to any bundle in it, so it names no bundle and
 * is not dropped by a per-bundle failure. Nor is a payload that only writes the
 * deck's scalars.
 *
 * A `withBundles` entry names no bundle either, because a create has no id to
 * name. If it is abandoned the bundle was never saved at all, and reseeding the
 * baseline from a fresh read is what takes it back out of the form.
 */
export function getWrittenBundleIds(
  input: AugmentedUpdateClientPresentationV2Input
): string[] {
  const bundleIds = (input.updateBundles ?? [])
    .filter((entry) => {
      const writesOnlyIndex =
        Object.keys(entry).length === 2 &&
        Object.keys(entry.update ?? {}).length === 1 &&
        entry.update?.index !== undefined;
      return !writesOnlyIndex;
    })
    .map((entry) => entry.id);

  return bundleIds;
}
